/*
  Sticky WhatsApp button behaviour for blocks/Whatsapp_jb_header.liquid.
  Moved out of the block on 2026-09-14: it was a 7.5KB inline script in the HTML of every page; as a deferred
  asset it is downloaded once and cached. Behaviour is unchanged: lift above product/rental sticky bars, hide
  while the footer is in view.
*/
  (function () {
    class CpStickyWhatsApp extends HTMLElement {
      constructor() {
        super();

        this.vAnchor = this.dataset.vAnchor; // "bottom" or "top"
        this.footer = null;

        this._scheduled = false;
        this._lastLift = -1;

        this._onScroll = this._onScroll.bind(this);
        this._onResize = this._onResize.bind(this);
        this._recompute = this._recompute.bind(this);
      }

      connectedCallback() {
        this.footer = document.querySelector('footer.footer, footer, .footer, .site-footer, [role="contentinfo"]');

        // Set base bottom as CSS variable (stable)
        this._applyBaseBottom();

        // Hide when footer scrolls into view (matches rental-sticky behaviour)
        this._attachFooterObserver();

        // Initial compute
        this._scheduleRecompute();

        // Event-driven updates (no 60fps loop)
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });

        // Mobile browser UI changes (address bar) — helps on iOS/Android
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this._onResize, { passive: true });
          window.visualViewport.addEventListener('scroll', this._onResize, { passive: true });
        }

        // If the product sticky bar flips data-visible, update lift immediately
        this._observeProductBar();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);

        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this._onResize);
          window.visualViewport.removeEventListener('scroll', this._onResize);
        }

        if (this._mo) this._mo.disconnect();
        if (this._ro) this._ro.disconnect();
        if (this._footerObserver) this._footerObserver.disconnect();
      }

      _applyBaseBottom() {
        const isMobile = window.innerWidth < 750;
        const base = parseInt(isMobile ? this.dataset.bMobile : this.dataset.bDesktop, 10) || 0;
        if (base === this._lastBase) return;
        this._lastBase = base;
        this.style.setProperty('--ai-base-bottom', base + 'px');
      }

      _observeProductBar() {
  const sel = this.dataset.productBarSelector || '';
  if (!sel) return;

  const attachAll = () => {
    const bars = Array.from(document.querySelectorAll(sel));
    if (!bars.length) return false;

    bars.forEach((bar) => this._attachObservers(bar));
    return true;
  };

  if (!attachAll()) {
    // Shopify can hydrate late
    setTimeout(() => {
      attachAll();
      this._scheduleRecompute(); // force once after late attach
    }, 300);
  } else {
    this._scheduleRecompute(); // force once immediately
  }
}

_attachObservers(bar) {
  // Avoid double-attaching
  if (bar._aiObserved) return;
  bar._aiObserved = true;

  // Attribute changes (data-visible, class, inline styles)
  this._mo = this._mo || new MutationObserver(() => this._scheduleRecompute());
  this._mo.observe(bar, { attributes: true, attributeFilter: ['data-visible', 'class', 'style'] });

  // Height changes (bar expands/collapses)
  if (window.ResizeObserver) {
    this._ro = this._ro || new ResizeObserver(() => this._scheduleRecompute());
    this._ro.observe(bar);
  }
}


      _getProductBarLift() {
  const sel = this.dataset.productBarSelector || '';
  if (!sel) return 0;

  const nodes = Array.from(document.querySelectorAll(sel));
  if (!nodes.length) return 0;

  const isHidden = (el) => {
    const cs = window.getComputedStyle(el);
    // NOTE: do NOT check pointer-events (some wrappers intentionally set it to none)
    return (
      cs.display === 'none' ||
      cs.visibility === 'hidden' ||
      parseFloat(cs.opacity || '1') < 0.05

    );
  };
  const isExplicitlyHiddenByState = (node) => {
  // If it's your sticky CTA custom element, trust its data-visible state
  if (node?.tagName?.toLowerCase() === 'sticky-button') {
    return node.getAttribute('data-visible') === 'false';
  }
  return false;
};


  const qualifiesAtBottom = (el) => {
  const r = el.getBoundingClientRect();
  if (r.height <= 0) return false;

  // MUST be at least partially inside the viewport
  const intersectsViewport = r.top < window.innerHeight - 1 && r.bottom > 1;
  if (!intersectsViewport) return false;

  // Docked near the bottom edge
  return r.bottom >= window.innerHeight - 2;
};


  let maxH = 0;

  for (const node of nodes) {
    // If it's a wrapper, measure its visible card if present
    const card = node.classList?.contains('product-sticky-form__card')
      ? node
      : node.querySelector?.('.product-sticky-form__card');

    // Candidate elements to measure (prefer card, fallback to node)
    const candidates = card ? [card] : [node];

    for (const el of candidates) {
      if (!qualifiesAtBottom(el)) continue;
      if (isHidden(el)) continue;

      const h = Math.ceil(el.getBoundingClientRect().height);
      maxH = Math.max(maxH, h);
    }
  }

  return maxH;
}


      _getSafeAreaInsetBottom() {
        // If theme uses safe-area inset, this helps avoid iPhone home indicator overlap.
        // getComputedStyle() is cheap here since it's not in a tight loop.
        const v = getComputedStyle(document.documentElement).getPropertyValue('env(safe-area-inset-bottom)');
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
      }

      _recompute() {
        this._scheduled = false;

        // Hide when overlapping footer (your original behavior)
        this._handleFooterHide();

        // Only bottom anchor needs lifting
        if (this.vAnchor !== 'bottom') return;

        // Measure first, then write: writing the style before measuring forced a synchronous layout on every
        // scroll frame (Lighthouse "forced reflow"). The base bottom is also only written when it changes.
        const GAP = 5; // ← EXACT gap you want

const productLift = this._getProductBarLift();
        this._applyBaseBottom();
let lift = 0;

if (productLift > 0) {
  lift = productLift + GAP;
}


        if (lift !== this._lastLift) {
          this.style.setProperty('--ai-lift', lift + 'px');
          this._lastLift = lift;
        }
      }

      _scheduleRecompute() {
        if (this._scheduled) return;
        this._scheduled = true;
        requestAnimationFrame(this._recompute);
      }

      _attachFooterObserver() {
        const setup = () => {
          if (!this.footer) {
            this.footer = document.querySelector('footer.footer, footer, .footer, .site-footer, [role="contentinfo"]');
          }
          if (!this.footer) return;
          this._footerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('hidden', entry.isIntersecting);
            });
          }, { threshold: 0, rootMargin: '0px 0px 80px 0px' });
          this._footerObserver.observe(this.footer);
        };

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          requestAnimationFrame(setup);
        } else {
          document.addEventListener('DOMContentLoaded', setup, { once: true });
        }
      }

      _handleFooterHide() {
        // Footer hide is now handled by IntersectionObserver in _attachFooterObserver
      }

      _onScroll() {
        this._scheduleRecompute();
      }

      _onResize() {
        this._scheduleRecompute();
      }
    }

    // Each block instance renders a uniquely named element (sticky-button-<block id>); define every one on the page.
    // Custom element classes cannot be shared between names, so each gets its own subclass.
    function defineAll() {
      document.querySelectorAll('[data-cp-sticky-whatsapp]').forEach(function (el) {
        var tag = el.localName;
        if (!customElements.get(tag)) customElements.define(tag, class extends CpStickyWhatsApp {});
      });
    }
    defineAll();
    // Theme editor: a newly added or re-rendered block brings a new element.
    document.addEventListener('shopify:section:load', defineAll);
    document.addEventListener('shopify:block:select', defineAll);
  })();
